import { date } from 'quasar';
import { api } from 'boot/axios';
import { LocalStorage, Dialog, Loading } from 'quasar';
import {
  getAuth,
  sendPasswordResetEmail,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider
} from 'firebase/auth';
import { apiV2 } from 'boot/axios';
import { initializeApp } from 'firebase/app';

export function changePassword({ commit }, payload) {
  // Loading.show({ spinner: QSpinnerDots });

  let auth = getAuth();
  let user = auth.currentUser;
  let email = user.email;
  let password = payload.oldPassword;

  /*let credential = auth.EmailAuthProvider.credential(
      email, 
      password,
  )*/
  //reauthenticateWithCredential(user, credential)

  signInWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
      let credential = EmailAuthProvider.credential(email, password);
      reauthenticateWithCredential(user, credential);

      // Signed in
      updatePassword(user, payload.newPassword)
        .then((response) => {
          // Call API to get User Data
          api
            .post('/api/users/', {
              table: 'users',
              action: 'password',
              email: email
            })
            .then((response) => {})
            .catch((error) => {
              return error.message;
              Dialog.create({ title: 'Error', message: error.message });
            });
          // Loading.hide();
        })
        .catch((error) => {
          Dialog.create({
            title: 'Something went wrong',
            message: error.message.replace('Firebase: ', '')
          });
        });
      // Loading.hide();

      return true;
    })
    .catch((error) => {
      // Loading.hide();
      Dialog.create({
        title: 'Something went wrong',
        message: error.message.replace('Firebase: ', '')
      });
    });

  return false;
}

export function recoverPassword({ commit }, email) {
  // Loading.show({ spinner: QSpinnerDots });

  let auth = getAuth();

  sendPasswordResetEmail(auth, email)
    .then((response) => {
      // Loading.hide();
    })
    .catch((error) => {
      // Loading.hide();
      Dialog.create({ title: 'Error', message: error.message });
    });
}

export function changeName({ commit }, payload) {
  /* Loading.show({
    spinner: QSpinnerDots
  }); */
  let user = firebaseAuth.currentUser;
  user
    .updateProfile({ displayName: payload })
    .then((response) => {
      // Save name in settings locale data
      commit('settings/setName', payload, { root: true });
      // Loading.hide();
    })
    .catch((error) => {
      // Loading.hide();
      Dialog.create({ title: 'Error', message: error.message });
    });
}
export function registerUser({ commit, dispatch }, payload) {
  const auth = getAuth();
  /* Loading.show({
    spinner: QSpinnerDots
  }); */
  // Update email and password
  createUserWithEmailAndPassword(auth, payload.email, payload.password)
    .then((response) => {
      let user = auth.currentUser;

      // Get User Data
      let params = {
        user_id: auth.currentUser.uid,
        email: payload.email,
        role: payload.userType.toUpperCase(),
        markets: payload.markets.id ? [payload.markets.id] : '',
        destinations: payload.destinations.label
          ? [payload.destinations.label]
          : '',
        name: payload.name,
        organization: payload.organization,
        origin: payload.origin.label,
        newsletter: payload.ad,
        deleted: 0,
        pending: 1,
        paid: 0,
        verification: 0,
        time_created: date.formatDate(Date.now(), 'YYYY-MM-DD HH:mm:ss')
      };

      // Calculate expiration
      let role = payload.userType.toUpperCase();
      let expiration = new Date();

      if (role == 'FREE' || role == 'PREMIUM' || role == 'ENTERPRISE') {
        if (role == 'FREE')
          expiration = date.addToDate(expiration, { days: 60 });
        else expiration = date.addToDate(expiration, { days: 366 });

        params['expiration'] = date.formatDate(expiration, 'YYYY-MM-DD');
      }

      // Call API to get User Data
      api
        .post('/api/users/', {
          table: 'users',
          action: 'insert',
          payload: params
        })
        .then((response) => {
          // Update user info in app
          commit('travellyze/setUser', params, { root: true });
          // Loading.hide();
          this.$router.replace('/');
        })
        .catch((error) => {
          return error.message;
          Dialog.create({ title: 'Error', message: error.message });
        });
    })
    .catch((error) => {
      // Loading.hide();
      Dialog.create({ title: 'Error', message: error.message });
    });
  return false;
}

export function registerUserReport({ commit, dispatch }, params) {
  const auth = getAuth();
  /* Loading.show({
    spinner: QSpinnerDots
  }); */
  let payload = params.formData;
  let type = params.type;
  let market = params.market;

  // Update email and password
  createUserWithEmailAndPassword(auth, payload.email, payload.password)
    .then((response) => {
      let user = auth.currentUser;

      // Get User Data
      let params = {
        user_id: auth.currentUser.uid,
        email: payload.email,
        role: 'FREE',
        markets: '["report"]',
        destinations: '["report"]',
        name: payload.name,
        organization: payload.organization,
        origin: payload.origin,
        newsletter: payload.ad,
        phone: payload.phone,
        deleted: 0,
        pending: 0,
        paid: 0,
        verification: 0,
        time_created: date.formatDate(Date.now(), 'YYYY-MM-DD HH:mm:ss')
      };

      // Calculate expiration
      let expiration = new Date();
      expiration = date.addToDate(expiration, { days: 366 });
      params['expiration'] = date.formatDate(expiration, 'YYYY-MM-DD');

      // Call API to get User Data
      api
        .post('/api/users/', {
          table: 'users',
          action: 'insert',
          payload: params
        })
        .then((response) => {
          // Update user info in app
          commit('travellyze/setUser', params, { root: true });
          // Loading.hide();
          this.$router.replace('/reports/create/' + type + '/' + market);
        })
        .catch((error) => {
          return error.message;
          Dialog.create({ title: 'Error', message: error.message });
        });
    })
    .catch((error) => {
      // Loading.hide();
      Dialog.create({ title: 'Error', message: error.message });
    });
  return false;
}

export function registerUserEvents({ commit, dispatch }, payload) {
  const auth = getAuth();
  // Loading.show({
  //   delay: 2000,
  //   spinner: QSpinnerDots
  // });

  // Update email and password
  createUserWithEmailAndPassword(auth, payload.email, payload.password)
    .then((response) => {
      // Loading.show({
      //   spinner: QSpinnerDots
      // });
      let user = auth.currentUser;

      // Get User Data
      let params = {
        user_id: auth.currentUser.uid,
        email: payload.email,
        role: 'EVENT_ENTERPRISE',
        markets: '',
        destinations: '',
        name: payload.name,
        organization: payload.organization,
        origin: payload.origin,
        newsletter: payload.ad,
        phone: payload.phone,
        coupon: payload.coupon,
        deleted: 0,
        paid: 0,
        verification: 0,
        time_created: date.formatDate(Date.now(), 'YYYY-MM-DD HH:mm:ss')
      };

      // Calculate expiration
      let expiration = new Date();
      expiration = date.addToDate(expiration, { days: 1 });
      params['expiration'] = date.formatDate(expiration, 'YYYY-MM-DD');

      // Call API to get User Data
      api
        .post('/api/users/', {
          table: 'users',
          action: 'insert',
          payload: params
        })
        .then((response) => {
          // Update user info in app
          commit('travellyze/setUser', params, { root: true });
          // Loading.hide();
          this.$router.replace('/');
        })
        .catch((error) => {
          // Loading.hide();
          return error.message;
          Dialog.create({ title: 'Error', message: error.message });
        });
    })
    .catch((error) => {
      // Loading.hide();
      Dialog.create({ title: 'Error', message: error.message });
    });
  return false;
}

export function loginUser({ commit, dispatch }, payload) {
  const auth = getAuth();
  /* Loading.show({
    spinner: QSpinnerDots
  }); */
  signInWithEmailAndPassword(auth, payload.email, payload.password)
    .then((response) => {
      // Get User Info
      dispatch('getUser', {
        table: 'users',
        action: 'select',
        user_id: auth.currentUser.uid
      });

      // Log In
      commit('setLoggedIn', true);

      this.$router.replace('/');
      // Loading.hide();
    })
    .catch((error) => {
      // Loading.hide();
      Dialog.create({
        title: 'Unable to Login',
        message: 'Check email and/or password.'
      });
    });
}

export function loginOut({ commit }) {
  const auth = getAuth();
  /* Loading.show({
    spinner: QSpinnerDots
  }); */
  auth.signOut().then(
    function () {
      let params = {
        email: '',
        name: '',
        role: '',
        destinations: [],
        user_id: '',
        token_id: '',
        markets: [],
        destinations: []
      };
      commit('questions/deleteReports', [], { root: true });
      commit('questions/deleteProfiles', [], { root: true });
      commit('travellyze/setUser', params, { root: true });
      commit('questions/clearProfile', params, { root: true });
      commit('setLoggedIn', false);
      dispatch('redirect', null);
      // Loading.hide();
    },
    function (error) {
      showErrorMessage(error);
    }
  );
}

export function refreshFavorites({ commit }) {
  const auth = getAuth();

  api
    .post('/api/users/', {
      table: 'favorites',
      action: 'select_all',
      user_id: auth.currentUser.uid
    })
    .then((response) => {
      // Save data
      let favoriteData = response.data.data;
      if (favoriteData) {
        commit('questions/deleteProfiles', [], { root: true });
        Object.keys(favoriteData).forEach(function (key) {
          let payload = {
            index: favoriteData[key].favorite_id,
            profile: favoriteData[key]
          };
          commit('questions/createProfile', payload, { root: true });
        });
      }
    })
    .catch((error) => {
      Dialog.create({ title: 'Error', message: error.message });
      return error.message;
    });
}
export function getUser({ commit }) {
  // Get User Data
  let userData = {};

  // Call API to get User Data
  apiV2
    .get('/auth/profile/v1')
    .then((response) => {
      // Save data
      userData = response.data;
      if (userData) {
        commit('travellyze/setUser', userData, { root: true });
        commit('setLoggedIn', true);

        userData.favorites.forEach(function (favorite) {
          let payload = {
            index: favorite.favorite_id,
            profile: favorite
          };
          commit('questions/createProfile', payload, { root: true });
        });
      }
    })
    .catch((error) => {
      Dialog.create({ title: 'Error', message: error.message });
      return error.message;
    });

  // Call API to get REPORTS
  //   api
  //     .post('/api/users/', {
  //       table: 'reports',
  //       action: 'select_all',
  //       user_id: params.user_id
  //     })
  //     .then((response) => {
  //       // Save data
  //       let reportData = response.data.data;
  //       if (reportData) {
  //         Object.keys(reportData).forEach(function (key) {
  //           commit('questions/addReport', reportData[key], { root: true });
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       return error.message;
  //       Dialog.create({ title: 'Error', message: error.message });
  //     });

  // Call API to get FAVORITES
  //   api
  //     .post('/api/users/', {
  //       table: 'favorites',
  //       action: 'select_all',
  //       user_id: params.user_id
  //     })
  //     .then((response) => {
  //       // Save data
  //       let favoriteData = response.data.data;
  //       if (favoriteData) {
  //   Object.keys(favoriteData).forEach(function (key) {
  //     let payload = {
  //       index: favoriteData[key].favorite_id,
  //       profile: favoriteData[key]
  //     };
  //     commit('questions/createProfile', payload, { root: true });
  //   });
  //       }
  //     })
  //     .catch((error) => {
  //       return error.message;
  //       Dialog.create({ title: 'Error', message: error.message });
  //     });

  // Call API to get INSIGHTS
  //   api
  //     .post('/api/insights/', { user_id: params.user_id })
  //     .then((response) => {
  //       // Save data
  //       let insights = response.data;
  //       if (insights) {
  //         commit('travellyze/addInsights', insights, { root: true });
  //       }
  //     })
  //     .catch((error) => {
  //       return error.message;
  //       Dialog.create({ title: 'Error', message: error.message });
  //     });
}

export function createNewUser({ commit, dispatch }, payload) {
  /* Loading.show({
    spinner: QSpinnerDots
  }); */
  // Update email and password

  // Import the functions you need from the SDKs you need

  // TODO: Add SDKs for Firebase products that you want to use

  // https://firebase.google.com/docs/web/setup#available-libraries

  // Your web app's Firebase configuration

  const firebaseConfig = {
    apiKey: 'AIzaSyDdbZcXfbE-rnjvF4qk6aTxzOFJv6ShK_M',
    authDomain: 'travellyze.firebaseapp.com',
    projectId: 'travellyze',
    storageBucket: 'travellyze.appspot.com',
    messagingSenderId: '285663313902',
    appId: '1:285663313902:web:0bfbe805730df5689a58ff'

    // apiKey: 'AIzaSyCNDebPODzox5Vc15-QVNSAxvI2NSvQ-Qg',
    // authDomain: 'travellyze-test.firebaseapp.com',
    // projectId: 'travellyze-test',
    // storageBucket: 'travellyze-test.appspot.com',
    // messagingSenderId: '228643221213',
    // appId: '1:228643221213:web:4a09cebc3576bbae79f534',
    // measurementId: 'G-DW8BZ14GVC'
  };

  // Initialize Firebase

  const app2 = initializeApp(firebaseConfig, 'secondary');
  const auth = getAuth(app2);
  createUserWithEmailAndPassword(auth, payload.email, payload.password).then(
    (response) => {
      let user = auth.currentUser;
      let params = payload;

      // Get User Data
      params['user_id'] = auth.currentUser.uid;
      delete params['password'];
      delete params['password2'];

      // Call API to get User Data
      apiV2.post('users/create/v1', params).then((response) => {
        this.$router.go(0);
        Loading.hide();
      });
    }
  );
  return false;
}

export function editUser({ commit, dispatch }, payload) {
  /* Loading.show({
    spinner: QSpinnerDots
  }); */
  delete payload['password'];
  delete payload['password2'];

  // Call API to get User Data
  api
    .post('/api/users/', {
      table: 'users',
      action: 'update',
      user_id: payload.user_id,
      payload: payload
    })
    .then((response) => {
      commit('questions/updateUser', payload, { root: true });
    })
    .catch((error) => {
      Dialog.create({ title: 'Error', message: error.message });
    })
    .finally(() => {
      Loading.hide();
    });
}

export function redirect({ commit }, params) {
  if (
    this.$router.currentRoute.name !== 'ValidateAccount' &&
    this.$router.currentRoute.name !== 'Register' &&
    this.$router.currentRoute.name !== 'RegisterEvent' &&
    this.$router.currentRoute.name !== 'RegisterReport' &&
    this.$router.currentRoute.name !== 'Surveys' &&
    this.$router.currentRoute.name !== 'Survey' &&
    this.$router.currentRoute.name !== 'NewSurvey'
  ) {
    this.$router.push('/login').catch(() => {});
  }
}

function getCookie(name) {
  const cookies = document.cookie.split('; ');
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=');
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null; // Cookie not found
}

export function handleAuthStateChange({ commit, dispatch }) {
  const impersonateUserIdCookie = getCookie('impersonated_user');
  if (impersonateUserIdCookie) {
    // Get user Info
    dispatch('getUser', {
      table: 'users',
      action: 'select',
      user_id: impersonateUserIdCookie
    });
  } else {
    // Firebase connect
    Loading.show();
    const auth = getAuth();
    auth.onIdTokenChanged((user) => {
      if (user) {
        apiV2.defaults.headers.common.Authorization = `Bearer ${user.accessToken}`;
        // Get User Info
        dispatch('getUser', {
          table: 'users',
          action: 'select',
          user_id: auth.currentUser.uid
        });
        Loading.hide();
      }
    });
  }
}

export function impersonateUser({ commit, dispatch }, userId) {
  // Call API to get User Data
  api
    .post('/api/users/impersonate.php', { userId })
    .then((response) => {
      // Save data
      const user = response.data;
      if (user) {
        commit('travellyze/setUser', user, { root: true });

        // User set Log In
        commit('setLoggedIn', true);
        LocalStorage.set('loggedIn', true);

        // Set cookie expires in 1 hour
        document.cookie = `impersonated_user=${userId}; path=/; expires=${new Date(
          Date.now() + 3600000
        ).toUTCString()}`;

        // Idk why but you should redirect to home page before
        // handling auth state change or it will throw an error
        // this.$router.replace('/');
        window.location.href = '/';

        // Handle auth state change
        commit(handleAuthStateChange({ commit, dispatch }));
      }
    })
    .catch((e) => {
      console.error(e);
    });
}

export function stopImpersonatingUser({ commit, dispatch }) {
  // Delete cookie from backend
  api
    .post('/api/users/impersonate.php', { userId: 'reset' })
    .then((response) => {
      // Delete cookie from frontend
      document.cookie =
        'impersonated_user=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;';

      // Go to homepage
      window.location.href = '/';
    });
}
